import React, {useState, useEffect} from 'react'
import {BaseButton, Box, Text} from '../../../../vanilla'
import {slotsErrorMessagingBox, slotsErrorMessagingButtonText} from './styles.css'
import useNavigation from '../../../../hooks/use-navigation'
import {useContentStore} from '../../../../store/hooks/useStore'

interface SlotsErrorMessagingProps {
    error?: boolean
}

const SlotsErrorMessaging = ({error}: SlotsErrorMessagingProps) => {
    const navigate = useNavigation()
    const cms = useContentStore()
    const [errorMessage, setErrorMessage] = useState('')
    const messageToDisplay = error ? 'delivery-slots-error-text' : 'delivery-slots-unavailable-text'

    const buttonLink = () => {
        if (error && typeof window !== 'undefined') {
            window.location.reload()
        } else {
            navigate('/store-finder')
        }
    }

    // Determine which message to show based on the error prop
    useEffect(() => {
        (async function () {
            if (!cms.contentById[messageToDisplay]) {
                await cms.fetchItemByKey(messageToDisplay)
            }
            const errorContent = cms.contentById[messageToDisplay]
            if (errorContent?.text) {
                setErrorMessage(errorContent.text)
            } else {
                // Fallback message in case of no Amplience content
                setErrorMessage(error 
                    ? 'Delivery slots are temporarily unavailable. Please try again after a few minutes.' 
                    : 'Sorry, there are currently no slots available. Try again later or check your local store.')
            }
        })()
    }, [error])

return (
    <Box className={slotsErrorMessagingBox}>
        <Text variant='text3'>
            {errorMessage}
        </Text>
        <BaseButton
            as='a'
            aria-label={error ? 'Try again' : 'Store Finder'}
            onClick={() => {buttonLink()}}
        >
            <Text variant='text3' className={slotsErrorMessagingButtonText}>
                {error ? 'Try again' : 'Store Finder'}
            </Text>
        </BaseButton>
    </Box>
)}

export default SlotsErrorMessaging